export default __webpack_public_path__ + "static/media/backcover_13.b66f40a5.png";